import React, { useState, useEffect } from "react";
import "../assets/css/app.css";
import "../assets/css/custom.css";
import "../assets/css/responsive.css";
import { Web_Image_URL ,Image_URL} from "../config";

const Footer = () => {
  const [user, setUser] = useState("");

  useEffect(() => {
    // FIX: same pattern as Header.js — reading localStorage only once on
    // mount means Footer would show stale company info if it were ever
    // NOT remounted on navigation (e.g. a logout triggered from a modal
    // without a route change). Re-reading on the "storage" event (fired
    // by Login.js on login and Header.js's handleLogout on logout) keeps
    // this correct even in that case, at no cost when it isn't.
    const loadUserFromStorage = () => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        try {
          setUser(JSON.parse(storedUser));
        } catch {
          setUser("");
        }
      } else {
        setUser("");
      }
    };

    loadUserFromStorage();

    window.addEventListener("storage", loadUserFromStorage);
    return () => {
      window.removeEventListener("storage", loadUserFromStorage);
    };
  }, []);

  return (
    <footer id="site-footer" className="site-footer background four-columns">
      <div className="footer">
        <div className="section-padding">
          <div className="section-container">
            <div className="block-widget-wrap">
              <div className="row">
               
                {/* Column 3 */}
                <div className="col-lg-3 col-md-6 column-3">
                  <div className="block block-menu">
                    <h2 className="block-title">Help</h2>
                    <div className="block-content">
                      <ul>
                        {/* <li>
                          <a href="/shippingpolicy">Shipping & Return Policy</a>
                        </li> */}
                        <li>
                          <a href="/contact">Contact Us</a>
                        </li>
                        {/* <li>
                          <a href="/privacyPolicy">Privacy Policy</a>
                        </li>
                        <li>
                          <a href="#">Sitemap</a>
                        </li>
                        <li>
                          <a href="#">Warranty</a>
                        </li>
                        <li>
                          <a href="/returns">Return Requests</a>
                        </li> */}
                      </ul>
                    </div>
                    
                  </div>
                </div>

                {/* Column 4 */}
                <div className="col-lg-3 col-md-6 column-4">
                  <div className="block block-menu">
                    {/* <h2 className="block-title">Become an Insider</h2> 
                    <p>
                      Be first to get access to design trends, promotions and
                      exclusive offers.
                    </p>*/}
                    <div className="block-content">
                      {/* <div className="footer-newsletter">
                        <input
                          type="email"
                          className="footer-input"
                          placeholder="Email"
                        />
                        <button className="footer-subscribe-btn">
                          Subscribe
                        </button>
                      </div> */}
                      {/* <div className="footer-socials">
                        <p className="footer-socials-heading">Follow Us</p>
                        <div className="footer-icons">
                          <img
                            src={`${Web_Image_URL}img/facebook.png`}
                            alt="Facebook"
                            className="footer-icon"
                          />
                          <img
                            src={`${Web_Image_URL}img/instagram.png`}
                            alt="Instagram"
                            className="footer-icon"
                          />
                          <img
                            src={`${Web_Image_URL}img/pinterest.png`}
                            alt="Pinterest"
                            className="footer-icon"
                          />
                          <img
                            src={`${Web_Image_URL}img/youtube.png`}
                            alt="YouTube"
                            className="footer-icon"
                          />
                          <img
                            src={`${Web_Image_URL}img/twitter.png`}
                            alt="Twitter"
                            className="footer-icon"
                          />
                          <img
                            src={`${Web_Image_URL}img/linkedin.png`}
                            alt="LinkedIn"
                            className="footer-icon"
                          />
                          <img
                            src={`${Web_Image_URL}img/tiktok.png`}
                            alt="TikTok"
                            className="footer-icon"
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="section-padding">
          <div className="section-container">
            <div className="block-widget-wrap">
              <div className="row">
                <div className="col-md-6">
                  <div className="footer-left">
                    <p className="copyright">Copyright © {new Date().getFullYear()} {user.companyName} All Rights Reserved</p> 
                    
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="footer-right">
                    <div className="block block-image">
                      <img
  width="109"
                        height="32"
  src={
    user?.companyLogo
      ? `${Image_URL}Companylogo/${user.companyLogo}`
      : `${Web_Image_URL}img/West-End-Jewellery-Logo.png`
  }
  alt={user?.companyname || "West End Jewellery"}
/>

                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;